import React, { Component } from 'react';
import history from '../../history';

export class AlphaModeBanner extends Component {
    navigateToDashboard = () => {
        history.push('/dashboard');
    };

    render() {
        return (
            <div className="relative overflow-hidden bg-[#6A2C70] p-6 sm:p-12 rounded-2xl my-4 text-white">
                {/* Dark gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-[#6A2C70] via-[#B83B5E] to-[#6A2C70]" />

                {/* Enhanced Glow Effects */}
                <div className="absolute -bottom-32 right-0 w-2/3 h-[150%] bg-gradient-to-tl from-[#F08A5D]/30 via-[#F9ED69]/20 to-transparent blur-3xl animate-pulse" />
                <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-bl from-[#F9ED69]/25 via-[#F08A5D]/15 to-transparent blur-2xl animate-pulse" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#F9ED69]/[0.05] to-[#F08A5D]/[0.08]" />

                {/* Alpha Badge */}
                <div className="absolute -right-12 -top-12 w-48 h-48 rotate-12">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#F9ED69] to-[#F08A5D] rounded-full opacity-20 animate-pulse"></div>
                    <div className="absolute inset-2 bg-gradient-to-br from-[#F9ED69] to-[#F08A5D] rounded-full opacity-20 animate-pulse delay-100"></div>
                    <div className="absolute inset-4 bg-gradient-to-br from-[#F9ED69] to-[#F08A5D] rounded-full opacity-20 animate-pulse delay-200"></div>
                </div>

                <div className="flex flex-col lg:flex-row items-center justify-between relative z-10 gap-8 lg:gap-0">
                    {/* Content */}
                    <div className="relative z-10 w-full lg:max-w-xl">
                        <div className="flex items-center gap-4 mb-3">
                            <h1 className="text-3xl sm:text-4xl font-bold">
                                Alpha Mode Activated!
                            </h1>
                            <div className="animate-bounce">
                                <span className="inline-flex items-center px-4 py-1 rounded-full text-lg font-bold bg-gradient-to-r from-[#F9ED69] to-[#F08A5D] text-black shadow-lg shadow-[#F9ED69]/30">
                                    ALPHA
                                </span>
                            </div>
                        </div>

                        <div className="text-2xl font-bold mb-3 bg-clip-text text-transparent bg-gradient-to-r from-[#F9ED69] to-[#F08A5D]">
                            You're Testing Top-Secret Features!
                        </div>

                        <p className="text-base sm:text-lg leading-relaxed text-gray-100 mb-5 lg:pr-12">
                            Welcome to <span className="font-bold text-[#F9ED69]">Alpha Mode</span>, where you get to play with <span className="font-bold text-[#F08A5D]">experimental features</span> before anyone else! Features that require testing will be announced in the <span className="font-bold text-[#F9ED69]">Priority Hosting section on Discord</span>.
                        </p>

                        <div className="bg-[#B83B5E] p-3 rounded-lg mb-5 border-l-4 border-[#F9ED69]">
                            <p className="text-base font-medium">
                                <span className="font-bold text-[#F9ED69]">⚠️ WARNING:</span> Please <span className="font-bold underline">DO NOT</span> host your bots on this server as it is unreliable and constantly turned on and off for testing purposes.
                            </p>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={this.navigateToDashboard}
                                className="relative w-full sm:w-auto px-8 py-3 rounded-lg font-semibold overflow-hidden
                                    transition-all duration-200 hover:-translate-y-0.5 active:translate-y-0 
                                    group cursor-pointer"
                            >
                                {/* Gradient background */}
                                <div className="absolute inset-0 bg-gradient-to-r from-[#F9ED69] via-[#F5B349] to-[#F08A5D]
                                    group-hover:opacity-90 transition-opacity" />

                                {/* Shine effect */}
                                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent 
                                    translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" />

                                {/* Button shadow */}
                                <div className="absolute inset-0 shadow-xl shadow-[#F9ED69]/20" />

                                {/* Button text */}
                                <span className="relative z-10 flex items-center justify-center gap-2 text-black">
                                    Let's Explore!
                                </span>
                            </button>
                        </div>
                    </div>

                    {/* Cat Icon - Hidden on mobile */}
                    <div className="hidden lg:block relative z-10 w-[150px] mr-16">
                        <div className="animate-bounce glow-orange">
                            <img
                                src="https://cataas.com/cat"
                                alt="Alpha Cat"
                                className="w-36 h-36 object-cover rounded-full border-4 border-white/50 shadow-lg"
                            />
                            <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#F9ED69] to-[#F08A5D] rounded-full px-3 py-1 text-sm font-bold text-black shadow-lg shadow-[#F9ED69]/30 animate-pulse">
                                Alpha!
                            </div>
                        </div>
                    </div>
                </div>

                {/* Floating stars decoration */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
                    <div className="absolute top-2 right-[5%] text-[#F9ED69]/30 text-3xl animate-pulse delay-100">✦</div>
                    <div className="absolute top-16 right-[15%] text-[#F9ED69]/40 text-2xl animate-pulse delay-300">✧</div>
                    <div className="absolute top-4 right-[25%] text-[#F9ED69]/30 text-3xl animate-pulse delay-500">✦</div>
                    <div className="absolute top-20 right-[35%] text-[#F9ED69]/40 text-2xl animate-pulse delay-700">✧</div>
                </div>

                <style jsx>{`
                    .glow-orange {
                        filter: drop-shadow(0 0 10px rgba(249, 237, 105, 0.3));
                    }
                `}</style>
            </div>
        );
    }
}

export default AlphaModeBanner; 